var map = {
	"./BigShrvronDown.svg": "SYk7",
	"./Burger.svg": "4CPp",
	"./Exit.svg": "kJKo",
	"./Facebook.svg": "vepD",
	"./Instagram.svg": "Bu23",
	"./Lamp.svg": "qWK4",
	"./Logo.svg": "zV//",
	"./Phone.svg": "govq",
	"./PhoneLines.svg": "0J8v",
	"./ShevronDown.svg": "a3SO",
	"./Telegram.svg": "lncv",
	"./Viber.svg": "k98U",
	"./Whatsapp.svg": "kWfI",
	"./accuracy.svg": "a1/r",
	"./architect-icon.svg": "Oum0",
	"./arrowLeft.svg": "SXqm",
	"./arrowRight.svg": "aEUS",
	"./blueprints.svg": "YO8e",
	"./callback.svg": "wvwE",
	"./chairServices.svg": "z6kp",
	"./clock.svg": "dVsf",
	"./clock1.svg": "bk2j",
	"./close.svg": "ixtz",
	"./colors.svg": "USgk",
	"./concept.svg": "mbsC",
	"./consultation.svg": "vtu+",
	"./contrast.svg": "rNcL",
	"./cube.svg": "6VJl",
	"./cupboard.svg": "uYKU",
	"./ee.svg": "S6da",
	"./express.svg": "Owl7",
	"./frame.svg": "T8xr",
	"./fullScreen.svg": "vFOZ",
	"./google.svg": "2VDg",
	"./handshake.svg": "l2kJ",
	"./house.svg": "dQxn",
	"./houseNew.svg": "7drC",
	"./iconsCad/Clean.svg": "O+xa",
	"./iconsCad/Logo.svg": "5fdG",
	"./iconsCad/Union.svg": "ky3M",
	"./iconsCad/balcony.svg": "IbfZ",
	"./iconsCad/boiler.svg": "XhE1",
	"./iconsCad/change.svg": "2QbK",
	"./iconsCad/close.svg": "hqJr",
	"./iconsCad/delete.svg": "nctd",
	"./iconsCad/door.svg": "yMZB",
	"./iconsCad/down.svg": "cAbo",
	"./iconsCad/enter.svg": "N9PM",
	"./iconsCad/fit.svg": "TaF0",
	"./iconsCad/heater.svg": "5163",
	"./iconsCad/i.svg": "NLHG",
	"./iconsCad/left.svg": "jfUr",
	"./iconsCad/leftBalcony.svg": "b2uF",
	"./iconsCad/minus.svg": "etwR",
	"./iconsCad/mouse-pointer-solid.svg": "bGxn",
	"./iconsCad/pencil-alt-solid.svg": "TBbR",
	"./iconsCad/plus.svg": "jL6+",
	"./iconsCad/questionIcon.svg": "tssZ",
	"./iconsCad/redo.svg": "5E83",
	"./iconsCad/right.svg": "TOjb",
	"./iconsCad/rightBalcony.svg": "RcM6",
	"./iconsCad/save.svg": "+2eg",
	"./iconsCad/tube.svg": "oRk+",
	"./iconsCad/undo.svg": "tH1g",
	"./iconsCad/up.svg": "XFfI",
	"./iconsCad/vent.svg": "i3Vu",
	"./iconsCad/wall-svgrepo-com.svg": "XTkR",
	"./iconsCad/window-svgrepo-com.svg": "0WhF",
	"./infinity.svg": "W74Q",
	"./info.svg": "du3j",
	"./lampVizual.svg": "YyrB",
	"./left.svg": "K4Dd",
	"./lighting.svg": "daK0",
	"./location.svg": "0usL",
	"./magnifier.svg": "LUPa",
	"./materials.svg": "YREd",
	"./model.svg": "T5wE",
	"./no_limits.svg": "IRxE",
	"./palette.svg": "HoM8",
	"./palitra.svg": "itGw",
	"./pen.svg": "ZJLJ",
	"./pensile.svg": "0WW4",
	"./pin.svg": "hiuk",
	"./projects.svg": "GNYl",
	"./promoServices.svg": "zZlz",
	"./proposal.svg": "KLXD",
	"./right.svg": "N68g",
	"./ruler.svg": "VCJm",
	"./rulerServices.svg": "O9Re",
	"./screen.svg": "pWmf",
	"./style.svg": "NDDN",
	"./sun.svg": "OWEi",
	"./tapeMeasuring.svg": "NTLD",
	"./team.svg": "+3y6",
	"./textur.svg": "qzMZ",
	"./treeNew.svg": "FmYH",
	"./view.svg": "AO0S"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Z/fl";